import { render, staticRenderFns } from "./studentPart.vue?vue&type=template&id=20b1b041&scoped=true"
import script from "./studentPart.vue?vue&type=script&lang=js"
export * from "./studentPart.vue?vue&type=script&lang=js"
import style0 from "./studentPart.vue?vue&type=style&index=0&id=20b1b041&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b1b041",
  null
  
)

export default component.exports